import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './config';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../../services/paginatedList';

export interface Country {
  id: number;
  name: string;
  isoCode2?: string | null;
  isoCode3?: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export const useCountries = (
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions,
) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<PaginatedApiResponse<Country> | Country[]>(
    `${moduleConfig.module.api.list}${q}`,
    fetcher,
    { revalidateOnFocus: true },
  );
  const normalized = normalizePaginatedListResponse<Country>(data, page, limit);
  return {
    data: normalized.data,
    clients: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useCountry = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<Country>(
    id ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
